import type { BindPaymentMethodResult } from "@screen/Home/pages/Account/API/handlePaymentAPI";

/**
 * 3DS challenge 綁卡（§6）：綁卡結果若需要跳轉銀行驗證頁，回傳 payment_url；
 * 否則（frictionless bound）回傳 null，呼叫端照現狀走 bound 分支。
 */
export const shouldRedirectToChallenge = (result: BindPaymentMethodResult | null | undefined): string | null => {
  if (!result) return null;
  if (result.bind_status === "challenge_required" && result.payment_url) {
    return result.payment_url;
  }
  return null;
};
